export const stepStatuses = {
  SOLICITUDE: 1,
  NEEDS: 2,
  PEOPLE: 3,
  INFO: 4,
  DATA: 5,
  ACTIVITY: 6,
  FINANCIAL: 7,
  DOCUMENTS: 8,
  FINISHED: 9
}

export const peopleType = {
  1: 'responsibles',
  2: 'collaborators'
}
